import styled from 'styled-components';

export const Container = styled.div`
  border-radius: 20px;
  z-index: 2;
  background: var(--surface-1);
  color: var(--text-primary);
  box-shadow: var(--shadow-md);
  width: 100vw;
  height: 100vh;
  padding-top: 64px;
  
  h2 {
    margin-left: 32px;
  }

  span {
    margin-left: 32px;
  }

  h3 {
    color: var(--text-heading);
  }
`;

export const InnerContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin-top: 24px;
`;

export const Column = styled.div`
  display: flex;
  flex-direction: column;
`;

export const Label = styled.label`
  margin-bottom: 10px;
  font-weight: 700;
`;

export const Input = styled.input`
  padding: 10px;
  margin-bottom: 20px;
  
  border: 2px solid var(--border-default);
  border-radius: 4px;
  padding: 8px;
  font-size: 16px;
  outline: none;
  background: var(--input-bg);
  color: var(--text-primary);

  &::placeholder {
    color: var(--input-placeholder);
  }

  &:focus {
    border-color: var(--accent);
  }
`;

export const Span = styled.span`
  color: var(--text-secondary);
`;

export const ButtonContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  width: 100%;
`;

export const Button = styled.button`
  background-color: var(--accent);
  border-radius: 10px;
  box-shadow: var(--shadow-sm);
  color: var(--text-on-accent);
  cursor: pointer;
  display: inline-block;
  font-family: CerebriSans-Regular,-apple-system,system-ui,Roboto,sans-serif;
  padding: 7px 20px;
  text-align: center;
  text-decoration: none;
  transition: all 250ms;
  border: 0;
  font-size: 16px;
  user-select: none;
  -webkit-user-select: none;
  touch-action: manipulation;
  margin-top: 50px;
  margin-right: 16px;

  :hover {
  box-shadow: var(--shadow-md);
  transform: scale(1.02) ;
  }
`;
